import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private _successMessage = new Subject<string>();
  private _clientErrorMessage = new Subject<string>(); // 4xx errors
  private _serverErrorMessage = new Subject<string>(); // 5xx errors
  private _processMessage = new BehaviorSubject<string>('');

  constructor() {}

  get successMessage$() {
    return this._successMessage.asObservable();
  }

  get clientErrorMessage$() {
    return this._clientErrorMessage.asObservable();
  }

  get serverErrorMessage$() {
    return this._serverErrorMessage.asObservable();
  }

  get processMessage$() {
    return this._processMessage.asObservable();
  }

  success(msg: string) {
    this._successMessage.next(msg);
    this._processMessage.next('');
    setTimeout(() => {
      this._successMessage.next('');
    }, 3000);
  }

  // Client errors (4xx)
  clientError(msg: string, statusCode?: number) {
    this._clientErrorMessage.next(msg);
    setTimeout(() => {
      this._clientErrorMessage.next('');
    }, 5000);
  }

  // Server errors (5xx)
  serverError(msg: string, statusCode?: number) {
    this._serverErrorMessage.next(msg);
    setTimeout(() => {
      this._serverErrorMessage.next('');
    }, 5000);
  }

  // Generic error handler that routes to the appropriate error method
  error(msg: string, statusCode?: number) {
    if (statusCode && statusCode >= 500) {
      this.serverError(msg, statusCode);
    } else {
      this.clientError(msg, statusCode);
    }
  }

  process(msg: string) {
    this._processMessage.next(msg);
  }
}
